import styled, { css } from 'styled-components';
import theme from '../styles/theme';
import Pill from './Pill';

const TabGroup = styled.nav`
  border-bottom: 2px solid ${({ theme }) => theme.color.borderColor};
  display: flex;
  padding-left: ${({ theme }) => theme.spacing.x2};
  margin-bottom: ${({ theme }) => theme.spacing.x2};
`;

export const TabItem = styled.div<{
  active?: boolean;
  disabled?: boolean;
  isMobile?: boolean;
}>`
  color: ${({ active }) =>
    active ? theme.color.blue600 : theme.color.lightBlueGray600};
  font-weight: 700;
  font-size: 14px !important;
  margin-right: ${({ theme, isMobile }) =>
    isMobile ? theme.spacing.x1 : theme.spacing.x3};

  ${({ theme }) => theme.typography.UIText};
  /* ${({ active }) =>
    active &&
    css`
      font-weight: bold;
    `} */

  ${({ theme, disabled }) =>
    disabled &&
    css`
      color: ${theme.color.textMuted};
    `}

  cursor: pointer;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: ${({ theme }) => theme.spacing.xs};
    margin-top: ${({ theme }) => theme.spacing.x1};
    background-color: ${({ theme, active }) =>
      active ? theme.color.blue600 : 'transparent'};
    /* border-top-left-radius: ${({ theme }) => theme.spacing.xs};
    border-top-right-radius: ${({ theme }) => theme.spacing.xs}; */
    opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  }

  &:hover::after {
    ${({ theme, active }) =>
      !active && `background-color: ${theme.color.lightBackground};`}
  }
`;

export const TabBadge = styled(Pill)`
  margin-left: ${({ theme }) => theme.spacing.x1};
`;

export default TabGroup;
